/**
 * VisitTypeEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90001
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { PhaseEntity } from "../PhaseEntity";
import { BugGroupEntity } from "../BugGroupEntity";
import { BugStateEntity } from "../BugStateEntity";
import { VisitEntity } from "../VisitEntity";
import { VisitTypeEntity } from "../VisitTypeEntity";
declare global {
    interface EntityTypeMap {
        VisitType: VisitTypeEntity;
    }
}
export abstract class VisitTypeGeneratedEntity extends BaseEntity {
    public abstract visitTypeId: string;
    public abstract isDefault: boolean;
    public abstract eventPriority: number;
    public abstract templateName: string | null;
    public abstract templateId: string | null;
    public abstract name: string | null;
    public abstract visitAspects: string | null;
    public abstract project: ProjectEntity;
    public abstract phase: PhaseEntity | null;
    public abstract bugGroup: BugGroupEntity | null;
    public abstract openBugState: BugStateEntity | null;
    public abstract readonly visits: ReadonlyArray<VisitEntity>;
}
